export default "__VITE_ASSET__DkFUKK3s__"